import { RootState } from 'store/types';
import { createSelector } from 'reselect';
import { oc } from 'ts-optchain';

export const routerStateSelector = (state: RootState) => state.router;

export const currentLocationSelector = createSelector(routerStateSelector, router =>
  oc(router).location({ pathname: 'unknown' })
);

export const currentLocationPathNameSelector = createSelector(currentLocationSelector, location =>
  oc(location).pathname('unknown')
);

export const previousLocationSelector = createSelector(routerStateSelector, router =>
  oc(router).prevLocation({ pathname: 'unknown' })
);

export const previousLocationPathNameSelector = createSelector(previousLocationSelector, location =>
  oc(location).pathname('unknown')
);
